var map = {
	"./de/impressum.mdx": 4557,
	"./de/index.mdx": 89409,
	"./de/rechtliche-grundlagen.mdx": 57109,
	"./en/imprint.mdx": 24984,
	"./en/index.mdx": 83465,
	"./en/legal-framework.mdx": 47707,
	"./fr/cadre-juridique.mdx": 11325,
	"./fr/impressum.mdx": 85967,
	"./fr/index.mdx": 93817,
	"./it/colophon.mdx": 1630,
	"./it/index.mdx": 97058,
	"./it/quadro-giuridico.mdx": 96391
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 46549;
module.exports = webpackContext;